import { FC } from "react";

import { Locales } from "@simplyk/common";
import { UseFormReturn } from "react-hook-form";

import { NewsletterFormSignupData } from "../types";
import { newsletterSelectIconSx, newsletterSelectPlaceholderSx } from "../helpers/fieldStyles";

import { isRequired } from "@/common/helpers/validators";
import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardMenuItem } from "@/dashboard-design-system/MenuItem";
import { DashboardSelect } from "@/dashboard-design-system/Select";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

type NewsletterFormLanguageFieldProps = {
  form: UseFormReturn<NewsletterFormSignupData>;
  previewConfiguration?: {
    isPreview: boolean;
  };
};

export const NewsletterFormLanguageField: FC<NewsletterFormLanguageFieldProps> = ({ form }) => {
  const { t } = useTranslate();

  return (
    <DashboardSelect
      control={form.control}
      name="language"
      rules={[isRequired(t("dashboard", "newsletterForms.editor.step.questions.field.language.required"))]}
      data-test="form-language"
      renderValue={(value) => {
        if (!value) {
          return (
            <DashboardTypography variant="body2" sx={newsletterSelectPlaceholderSx}>
              {t("dashboard", "newsletterForms.editor.step.questions.field.language")}
            </DashboardTypography>
          );
        }
        return t("dashboard", `ContactFiltering.languages.${value as Locales}`);
      }}
      required
      error={Boolean(form.formState.errors.language?.message)}
      helperText={form.formState.errors.language?.message}
      sx={newsletterSelectIconSx}
    >
      <DashboardMenuItem value={Locales.EN} data-test="form-language-option">
        {t("dashboard", `ContactFiltering.languages.${Locales.EN}`)}
      </DashboardMenuItem>
      <DashboardMenuItem value={Locales.FR} data-test="form-language-option">
        {t("dashboard", `ContactFiltering.languages.${Locales.FR}`)}
      </DashboardMenuItem>
    </DashboardSelect>
  );
};
